const makeShortSizeCode = (sizeCode: string) => {
  if (!sizeCode) return ''
  if (sizeCode.includes('MM')) return Number(sizeCode.split('MM')[0])
  return sizeCode
}
export default makeShortSizeCode
